/**
 *
 * /RadioButton
 *
 */

import React from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function RadioButton({ label, name, onChange, checked, disabled, style, value, className, ...input_props }) {
	return (
		<label className="clickable d-inline-block" style={style}>
			<input
				type="radio"
				name={name}
				onChange={onChange}
				disabled={disabled}
				value={value}
				hidden
				checked={checked}
				{...input_props}
			/>
			<span className="fa-layers mx-2">
				<FontAwesomeIcon icon="circle" className="text-white" size="lg" />
				<FontAwesomeIcon
					icon={['far', checked ? 'check-circle' : 'circle']}
					className={`${className} `}
					size="lg"
				/>
			</span>
			&nbsp;
			{label}
		</label>
	)
}

RadioButton.propTypes = {
	label: PropTypes.string,
	name: PropTypes.string,
	onChange: PropTypes.func,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	style: PropTypes.object,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
	className: PropTypes.string,
}

RadioButton.defaultProps = {
	className: 'text-success',
}

export default RadioButton
